// extracted by mini-css-extract-plugin
module.exports = {"lekta-avatar":"_1yv92ihtgQphnOX-l-E9vd","dashboard":"_3jV7bRMfHr2HWneaVKGLgY"};